export default __webpack_public_path__ + "static/media/bg1.132d02d4.png";